<template>
  <!-- <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  > -->
  <div class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup" v-if="isSidebarActiveLocal" :class="{show: isSidebarActiveLocal}">
      <div class="cstm-modal medium fixed_medium">
        <div class="header">
          <h4>Add Custom Filter for {{ name | modifyTitle }}</h4>
          <button @click.stop="handlefilterSidebar" class="close-modal">&times;</button>
        </div>
        <form data-vv-scope="Add_Filter" style="height: auto; max-height: calc(100vh - 100px);" class="modal-content">
          <div class="px-4">
            <vs-input
              label="Enter Filter Name"
              class="mt-4 w-full"
              v-validate="'required'"
              data-vv-name="Filter Name"
              v-model="customFilterName"
            />
            <div
              v-if="errors.has('Add_Filter.Filter Name')"
              style="color: red"
              class="invalid-feedback"
            >
              {{ errors.first("Add_Filter.Filter Name") }}
            </div>
          </div>

          <vs-divider class="mb-0" />

          <div class="px-4 text-right">
            <vs-button
              @click="addNewFilter"
              color="primary"
              class="mt-3"
              type="filled"
              >Add More Filters</vs-button
            >
          </div>

          <div style="height: auto; max-height: calc(100vh - 400px) !important;" class="sidebar-scrollable-form more_filter_scrollbar vertical_scrollbar">
            <div class="p-4">
              <div
                class="previous"
                v-for="(dynamicfilter, counter) in dynamicfilters"
                v-bind:key="counter"
              >
                <vs-card class="mb-4">
                  <div slot="header" class="flex justify-between items-center">
                    <h5>Filter No. {{counter + 1}}</h5>
                    <vs-button
                        v-if="counter != 0"
                        @click="delterFilter(counter)"
                        color="danger"
                        radius
                        icon-pack="feather"
                        icon="icon-x"
                      ></vs-button>
                  </div>
                  <div class="vx-col w-full">
                    <div class="p-1">
                      <label class="vs-input--label">Field Name</label>
                      <select
                        style="background: #fff !important; padding: 12px"
                        class="form-control vs-select--input vs-select--input-con"
                        v-model="dynamicfilter.filterid"
                        @change="onSelectChange(dynamicfilter.filterid)"
                        v-validate="'required'"
                        data-vv-name="field name"
                        :name="`selectfield${counter}`"
                      >
                        <option
                          v-for="(fielddata, index) in visibleFields(fieldtabledata)"
                          :value="fielddata"
                          :key="index"
                          class="vs-select--options"
                        >
                          {{ fielddata.field_label === 'First Name' ?  'Full Name' : fielddata.field_label}}
                          <!-- {{fielddata.field_label}} -->
                        </option>
                      </select>
                      <div
                        v-if="errors.has(`Add_Filter.field name`)"
                        style="color: red"
                        class="invalid-feedback"
                      >
                        {{ errors.first(`Add_Filter.field name`) }}
                      </div>
                    </div>

                    <div class="p-1">
                      <label class="vs-input--label">Filter Condition</label>
                      <select
                        style="background: #fff !important; padding: 12px"
                        class="form-control vs-select--input vs-select--input-con"
                        v-validate="'required'"
                        data-vv-name="filter condition"
                        :name="`selectfilter${counter}`"
                        v-model="dynamicfilter.filtercondition"
                      >
                        <option
                          :value="filterdata"
                          v-for="(filterdata, index) in onSelectChange(
                            dynamicfilter.filterid
                          )"
                          :key="index"
                          class="vs-select--options"
                        >
                          {{ filterdata.platform_filter_name }}
                        </option>
                      </select>
                      <div
                        v-if="errors.has(`Add_Filter.filter condition`)"
                        style="color: red"
                        class="invalid-feedback"
                      >
                        {{ errors.first(`Add_Filter.filter condition`) }}
                      </div>
                    </div>

                    <!-- {{dynamicfilter}} -->
                    <!-- {{ filterdata }} -->
                    <div class="p-1">
                      <vs-input
                        v-if="
                          dynamicfilter.filtercondition.platform_field_name === 'number'
                        "
                        placeholder="Choose Values"
                        v-model="dynamicfilter.inputfieldvalue"
                        class="mb-1 w-full"
                        v-validate="'required|numeric'"
                        data-vv-name="filter"
                        :name="`filter${counter}`"
                      />

      <!-- {{dynamicfilter}} -->
                    <vs-input
                      v-if="dynamicfilter.filtercondition.platform_field_name === 'string'
                      && dynamicfilter.filtercondition.platform_field_name !== 'select'"
                      label="Enter the value"
                      placeholder="Enter Value"
                      v-model="dynamicfilter.inputfieldvalue"
                      class="mb-1 w-full"
                      v-validate="'required'"
                      data-vv-name="filter"
                      :name="`filter${counter}`"
                    />
                    <!-- {{ dynamicfilter.filterid }} -->
                    <!-- <vs-input
                      v-if="dynamicfilter.filtercondition.platform_field_name === 'string'"
                      placeholder="Choose Values"
                      v-model="dynamicfilter.inputfieldvalue"
                      class="mt-5 w-full"
                      v-validate="'required'"
                      :data-vv-name="`filter${counter}`"
                      :name="`filter${counter}`"
                    /> -->

                    <!-- checkbox -->
                    <li
                      v-if="(
                              (dynamicfilter.filterid.input_type === 'multiselect'
                                ||dynamicfilter.filterid.input_type === 'checkbox'
                              )
                              &&
                              dynamicfilter.filtercondition.platform_field_name === 'select'
                            )
                          "
                      class="mt-3"
                    >
                      <vs-checkbox
                        v-validate="'required'"
                        v-for="(multivalue,index) in dynamicfilter.filterid.multivalue"
                        :key="index"
                        v-model="dynamicfilter.inputmultiplefieldvalue"
                        :vs-value="multivalue.optionsvaluename"
                        >{{ multivalue.optionsvaluename }}
                      </vs-checkbox
                      >
                      <!-- {{dynamicfilter.inputmultiplefieldvalue}}
                      {{dynamicfilter.inputfieldvalue}} -->
                      <!-- <div
                            v-if="errors.has(`add.custom${custom_field.label}${index}`) && custom_field.inputtype === 'checkbox'"
                            style="color:red;"
                            class="invalid-feedback"
                          >{{ errors.first(`add.custom${custom_field.label}${index}`) }}</div> -->
                    </li>
                      <li
                      v-if="(dynamicfilter.filterid.input_type === 'select'||
                      dynamicfilter.filterid.input_type === 'radio' && dynamicfilter.filtercondition.platform_field_name === 'select')"
                      class="mt-3"
                    >
                      <vs-radio
                        v-validate="'required'"
                        v-for="multivalue in dynamicfilter.filterid.multivalue"
                        :key="multivalue.id"
                        v-model="dynamicfilter.inputfieldvalue"
                        :vs-value="multivalue.optionsvaluename"
                        :data-vv-name="`filter${counter}`"
                      :name="`filter${counter}`"
                        >{{ multivalue.optionsvaluename }}</vs-radio
                      >
                      <!-- <div
                            v-if="errors.has(`add.custom${custom_field.label}${index}`) && custom_field.inputtype === 'checkbox'"
                            style="color:red;"
                            class="invalid-feedback"
                          >{{ errors.first(`add.custom${custom_field.label}${index}`) }}</div> -->
                    </li>


                    <!-- checkbox -->

                    <!-- <vs-input
                      v-else-if="dynamicfilter.filtercondition.platform_field_name === 'string'"
                      placeholder="Choose Values"
                      v-model="dynamicfilter.inputfieldvalue"
                      class="mt-5 w-full"
                      v-validate="'required'"
                      :data-vv-name="`filter${counter}`"
                      :name="`filter${counter}`"
                    /> -->

                    <!-- {{dynamicfilter}} -->
                    <flat-pickr
                      class="mt-5 w-full"
                      v-if="
                        dynamicfilter.filtercondition.platform_field_name === 'date'
                      "
                      v-validate="'required'"
                      :data-vv-name="`filter${counter}`"
                      :name="`filter${counter}`"
                      :config="flatPickerConfig"
                      v-model="dynamicfilter.inputfieldvalue"
                    />

                    <ul
                      class="centerx"
                      v-if="
                        dynamicfilter.filtercondition.platform_field_name ===
                        'boolean'
                      "
                    >
                      <li>
                        <vs-radio v-model="dynamicfilter.inputfieldvalue" vs-value="1"
                          >True</vs-radio
                        >
                      </li>
                      <li>
                        <vs-radio v-model="dynamicfilter.inputfieldvalue" vs-value="0"
                          >False</vs-radio
                        >
                      </li>
                    </ul>

                    <div
                      v-if="errors.has(`Add_Filter.filter`)"
                      style="color: red"
                      class="invalid-feedback"
                    >
                      {{ errors.first(`Add_Filter.filter`) }}
                    </div>
                    </div>
                  </div>
                </vs-card>
              </div>

              <!-- v-for dynamicfilters -->

              <div class="vx-row mt-5">
                <div class="vx-col w-full" style="text-align: center">
                  <vs-button
                    primary
                    style="font-weight: 700"
                    class="mr-3"
                    @click="handleSaveFilter"
                    >Submit</vs-button
                  >
                </div>
              </div>
            </div>

        </div>
        </form>
      </div>
  </div>

</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { createNewFilter } from '@/api/filter'

export default {
  name: 'FilterSidebar',
  components: {
    flatPickr
  },
  created () {
    // this.fetchMainFilter('Lesson Notes')
    // this.fetchingDynamicFieldAndFilter()
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    platformmodulename: {
      type: String,
      required: true
    },
    fieldtabledata: {
      type: Array,
      default: () => []
    },
    filterconditiondata: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      flatPickerConfig: {
        altInput: true,
        altFormat: JSON.parse(localStorage.getItem('localization')).back_date_format,
        dateFormat: 'Y-m-d' // AS BACKEND ALWAYS EXPECTS THIS FORMAT ONLY
      },
      customFilterName: '',
      dynamicfilters: [
        {
          filterid: '',
          filtercondition: '',
          inputfieldvalue: '',
          inputmultiplefieldvalue:[]
        }
      ]
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$validator.reset()
          this.intidefault()
          this.$emit('closedsidebarevent', false)
        }
      }
    }
  },
  filters: {
    modifyTitle (name) {
      if (name === 'courseWork_template_table') {
        return 'Coursework Template'
      } else if (name === 'note_template_list') {
        return 'Notes Template'
      } else if (name === 'note_list') {
        return 'Notes'
      }  else if (name === 'courseWork_table') {
        return 'Coursework'
      } else if (name === 'report_template_table') {
        return 'Report Template'
      } else if (name === 'report_table') {
        return 'Report'
      } else if (name === 'exam_template_table') {
        return 'Exam Template'
      } else if (name === 'exam_table') {
        return 'Exam'
      } else if (name === 'crm_list') {
        return 'CRM'
      } else if (name === 'student_list') {
        return 'Student'
      } else if (name === 'staff_list') {
        return 'Staff'
      } else {
        return name
      }
    }
  },
  methods: {
    addNewFilter () {
      this.dynamicfilters.push({
        filterid: '',
        filtercondition: '',
        inputfieldvalue: '',
        inputmultiplefieldvalue:[]

      })
    },
    delterFilter (counter) {

      if (counter === 0) {
        this.$vs.notify({
          title: 'Warning',
          text: 'You cant delete first row',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 3000
        })
      } else {
        this.dynamicfilters.splice(counter, 1)
      }
    },
    visibleFields (fieldsArr) {
      const arrdata = fieldsArr.filter(function (element) {
        return !['Middle Name', 'Last Name'].includes(element.field_label)
      })
      return arrdata
    },
    onSelectChange (dynamicFilter) {

      // const award = this.filterconditiondata.map(element => element.platform_field_type === dynamicFilter.platform_field_types_id)
      if (dynamicFilter.table_type === 'system') {
        const arrdata = this.filterconditiondata.filter(function (element) {
          return (
            element.platform_field_type ===
            dynamicFilter.platform_field_types_id
          )
        })
        return arrdata
      } else {
        if (
          (dynamicFilter.platform_field_types_id === 'varchar' ||
          dynamicFilter.platform_field_types_id === 'text')) {
          if
          (dynamicFilter.input_type === 'textarea' || dynamicFilter.input_type === 'text') {
            dynamicFilter.platform_field_types_id = 'string'
          } else if ((dynamicFilter.input_type === 'multiselect' || dynamicFilter.input_type === 'radio' || dynamicFilter.input_type === 'checkbox' || dynamicFilter.input_type === 'select')) {
            dynamicFilter.platform_field_types_id = 'select'
          }
        }
        if (dynamicFilter.platform_field_types_id === 'integer') {
          dynamicFilter.platform_field_types_id = 'number'
        }
        if (dynamicFilter.platform_field_types_id === 'datetime') {
          dynamicFilter.platform_field_types_id = 'date'
        }
        if (dynamicFilter.platform_field_types_id === 'boolean') {
          dynamicFilter.platform_field_types_id = 'boolean'
        }
        const arrdata = this.filterconditiondata.filter(function (element) {
          return (
            element.platform_field_name ===
            dynamicFilter.platform_field_types_id
          )
        })
        return arrdata
      }
      //
    },
    // filter methods
    handleSaveFilter () {
      this.$validator.validateAll('Add_Filter').then((valid) => {
        if (valid) {


          const filterArr = this.dynamicfilters.map(function (element) {

            if (element.inputmultiplefieldvalue.length > 0) {
              element.inputfieldvalue = element.inputmultiplefieldvalue.join('+')
            }

            return {
              platform_module_filters_id: element.filtercondition.id,
              platform_filter_value: element.inputfieldvalue,
              platform_field_id: element.filterid.id,
              platform_module_field_type: element.filterid.table_type
            }
          })
          const customerId = this.$store.getters.customerId

          //
          const filterPayload = {
            filter_name: this.customFilterName,
            filter_condition: filterArr,
            platform_module_name: this.platformmodulename,
            type: this.platformmodulename,
            customerId,
            table_name: this.name
          }
          this.insertNewFilter(filterPayload)

          // this.filterList.push(filterPaylod)
          // this.customFilterName =  null
          // this.$vs.loading.close()
          // this.$vs.notify({
          //   title: 'Success',
          //   text: 'Filter Added Successfully',
          //   iconPack: 'feather',
          //   icon: 'icon-alert-circle',
          //   color: 'success'
          // })
          // this.filterSidebar = false
        } else {
          this.showSuccessMessage('Warning', 'All fields Are Mandatory', 'warning')

        }
      })
    },

    async insertNewFilter (payload) {
      try {
        const { data } = await createNewFilter(payload)

        const newFilter = data.data.filters
        // this.user_main_filter.push(data.data.filters)
        //
        this.initdefaultfiler(newFilter)
      } catch (e) {
        console.error(e)
      }
    },

    intidefault () {
      const dynamicfilternew = [
        {
          filterid: '',
          filtercondition: '',
          inputfieldvalue: '',
          inputmultiplefieldvalue:[]
        }
      ]
      this.dynamicfilters.length = 0
      this.dynamicfilters = dynamicfilternew
    },
    initdefaultfiler (newFilter) {
      const dynamicfilternew = [
        {
          filterid: '',
          filtercondition: '',
          inputfieldvalue: '',
          inputmultiplefieldvalue:[]

        }
      ]
      this.dynamicfilters.length = 0
      this.dynamicfilters = dynamicfilternew

      this.customFilterName = ''

      this.$vs.notify({
        title: 'Success',
        text: 'Filter Added Successfully',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
      this.$validator.reset()

      this.$emit('closedsidebarevent', newFilter)

      //   this.filterSidebar = false
    },
    handlefilterSidebar () {
      this.isSidebarActiveLocal = false
      document.body.classList.remove('overflow-hidden')
    }
  }
}
</script>


<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}

body {
  margin: 0;
}

.example-list-item {
  margin: 0;
  padding: 0 10px;
  font-size: 14px;
  line-height: 40px;
  color: #666;
  background-color: #fafafa;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #e3e3e3;
}

.example-list-item::before {
  content: "Line: ";
}

.con-vs-dialog .vs-dialog {
  z-index: 3000000000000000000000;
}
li {
  list-style: none;
}
.sidebar-scrollable-form.more_filter_scrollbar {
  height: calc(100vh - 200px) !important;
}
</style>
